import dbdata from '../assets/dbdata.json';

export default {
  fetchTkData({ commit }) {
    commit('SET_TK_DATA', dbdata);
  }
}


// WEBPACK FOOTER //
// ./src/store/actions.js